import {
  useLoaders,
  useTableColumnsProducto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  SearchComponente,
  GeneralTable,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AddIcon from "@mui/icons-material/Add";
import { useFetchGetProductoServicio } from "@/shared/actions/erp/producto_servicio.action";
import { IProductoServicio } from "@/shared/interfaces/erp/administration/producto_servicio.interface";

interface ModalServicioAdicionalesVentaProps {
  onChange: (e: IProductoServicio) => void;
  iconButton?: boolean;
  textButton?: string;
}

export default function ModalServicioAdicionalesVenta({
  iconButton = false,
  onChange,
  textButton = "Agregar Item",
}: ModalServicioAdicionalesVentaProps) {
  ///* State
  const [openModalProducto, setOpenModalProducto] = useState<boolean>(false);
  const { columnsEquipoAdicional } = useTableColumnsProducto();
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isloadingProducto,
    data: productoRes,
    isRefetching: isRefetchingProducto
  } = useFetchGetProductoServicio({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      descripcion: searchTerm.toUpperCase(),
      es_para_venta: true,
      ...filterObject,
      filterByState: false
    },
    enabled: openModalProducto
  });

  useLoaders(isloadingProducto);

  return (
    <>
      {iconButton ? (
        <Tooltip placement="top" title="Todos los inventariables">
          <IconButton onClick={() => setOpenModalProducto(true)} size="medium">
            <ManageSearchIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          startIcon={<AddIcon />}
          variant="outlined"
          onClick={() => {
            setOpenModalProducto(true);
          }}
        >
          {textButton}
        </Button>
      )}

      {openModalProducto && (
        <ScrollableDialogProps
          open={openModalProducto}
          title="Seleccionar"
          //cancelTextBtn="Cerrar"
          onCloseIcon={() => {
            setOpenModalProducto(false);
          }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SearchComponente
                  onChange={onChangeFilter}
                  value={globalFilter}
                  text="por descripción inventariable." />
              </Grid>

              <Grid item xs={12}>
                <GeneralTable<IProductoServicio>
                  columns={columnsEquipoAdicional}
                  data={productoRes?.data.data || []}
                  isLoading={isloadingProducto}
                  isRefetching={isRefetchingProducto}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={productoRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    onChange(e);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}

                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}

                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
